import { Controller } from "@hotwired/stimulus"

// Gemeinsame Backend-Sidebar-Komponente (CRM + Settings):
//  - Mobile: slide-in/out via Hamburger + Overlay
//  - Desktop: optional Collapse auf Icon-Only via Collapse-Button
//
// Pro Bereich eigener localStorage-Key durch Stimulus Value `storage-key`,
// damit CRM- und Settings-Zustand sich nicht gegenseitig ueberschreiben.
//
// CSS-Klassen: `app-sidebar-collapsed` / `app-sidebar-expanded` (siehe backend.scss).
export default class extends Controller {
  static targets = ["sidebar", "overlay"]
  static values  = { storageKey: { type: String, default: "app_sidebar" } }

  connect() {
    this.isOpen = false
    this.isCollapsed = localStorage.getItem(this.collapsedKey) === "true"
    if (this.isCollapsed && this.hasSidebarTarget) {
      this.applyCollapsed()
    } else if (this.hasSidebarTarget) {
      this.sidebarTarget.classList.add("app-sidebar-expanded")
    }
    this._boundMobileMenuToggle = this.toggle.bind(this)
    document.addEventListener("mobile-menu-toggled", this._boundMobileMenuToggle)
  }

  disconnect() {
    if (this._boundMobileMenuToggle) {
      document.removeEventListener("mobile-menu-toggled", this._boundMobileMenuToggle)
    }
  }

  get collapsedKey() {
    return `${this.storageKeyValue}_collapsed`
  }

  // Mobile slide-in
  toggle(event) {
    if (event && event.preventDefault) event.preventDefault()
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open(event) {
    if (event && event.preventDefault) event.preventDefault()
    if (!this.hasSidebarTarget) return
    this.isOpen = true
    this.sidebarTarget.classList.remove("-translate-x-full", "hidden")
    this.sidebarTarget.classList.add("translate-x-0", "lg:block")
    if (window.innerWidth < 1024 && this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden")
    }
  }

  close(event) {
    if (event && event.preventDefault) event.preventDefault()
    if (!this.hasSidebarTarget) return
    this.isOpen = false
    this.sidebarTarget.classList.add("-translate-x-full", "hidden")
    this.sidebarTarget.classList.remove("translate-x-0", "lg:block")
    if (this.hasOverlayTarget) this.overlayTarget.classList.add("hidden")
  }

  // Desktop collapse
  collapse(event) {
    if (event && event.preventDefault) event.preventDefault()
    this.isCollapsed = !this.isCollapsed
    localStorage.setItem(this.collapsedKey, this.isCollapsed)
    if (this.isCollapsed) {
      this.applyCollapsed()
    } else {
      this.applyExpanded()
    }
  }

  applyCollapsed() {
    if (!this.hasSidebarTarget) return
    this.sidebarTarget.classList.add("app-sidebar-collapsed")
    this.sidebarTarget.classList.remove("app-sidebar-expanded")
    this.sidebarTarget.querySelectorAll("nav a").forEach(a => {
      const label = a.querySelector('[data-app-sidebar-target="label"]') || a.querySelector("span")
      if (label) a.setAttribute("title", label.textContent.trim())
    })
  }

  applyExpanded() {
    if (!this.hasSidebarTarget) return
    this.sidebarTarget.classList.remove("app-sidebar-collapsed")
    this.sidebarTarget.classList.add("app-sidebar-expanded")
    this.sidebarTarget.querySelectorAll("nav a[title]").forEach(a => a.removeAttribute("title"))
  }
}
